export default __webpack_public_path__ + "0bf9e2e7dbae001d75b31f179d95c7ba.svg";